import { isPlatformBrowser } from '@angular/common';
import {
  Component,
  Inject,
  OnInit,
  PLATFORM_ID,
} from '@angular/core';
import {
  AbstractControl,
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import {
  ActivatedRoute,
  Router,
} from '@angular/router';

import {
  B2C_LOOKUP,
  paymentCurrencyOptions,
} from 'app/lookup-config';
import { share } from 'rxjs/operators';
import Swal from 'sweetalert2';

import { environment } from '@env/environment';
import {
  UntilDestroy,
  untilDestroyed,
} from '@ngneat/until-destroy';
import { CommonService } from '@services/common.service';
import { SharedService } from '@services/shared.service';
import { YTBSEOService } from '@services/ytb-seo.service';
import { YTBCommonService } from 'services';

// var creditCardType = require('credit-card-type');
// declare var JSEncrypt: any;
import creditCardType from 'credit-card-type';

declare var Razorpay: any;

@UntilDestroy()
@Component({
    selector: 'app-makeExternalPayment',
    templateUrl: './makeExternalPayment.component.html',
    providers: []
})
export class MakeExternalPaymentsComponent implements OnInit {
    isLoading: boolean = false;
    userNotFounfShowFail: boolean = false;
    userNotFoundShowSuccess: boolean = false;
    userNotFoundMessageInfo: any = {};
    paymentCurrencyOptions = paymentCurrencyOptions;
    termsandcondi: any;

    termsandconditons: Boolean = false;
    credit: boolean = true;
    paypal: boolean = false;
    creditcard: boolean = true;
    cvvLength: number = 3;
    cvvmaxlength: any;
    maxlength: any;
    cardImg: string = null;
    sameaddr: boolean = false;

    PersonalForm: UntypedFormGroup;
    paymentForm: UntypedFormGroup;
    BillingForm: UntypedFormGroup;
    typeofPayment: UntypedFormGroup;
    currentCurrency: string;
    viewMode: string;
    modeCurrency: string;
    allCountryList: Array<any> = [];
    stateResponseForPersonalAddress:Array<any> = [];

    public_key;
    yearArray;
    monthArray;
    paymentTypes: Array<any> = [
        { label: 'Credit Card', value: 'creditcard', key: 1 }
    ];


    addressTypes: Array<any> = [
        { label: 'Use Billing Address as Personal Address same', value: 'sameaddress', id: "billingaddrs" },
        { label: 'Provide Personal address', value: 'billaddress', id: "personaladdrs" }
    ];

    bookingdata: any;

    countrylist: Array<any>;
    countrycodes: Array<any>;
    stateArr: any;
    stateList: any;
    cardImage:string="";
    
    constructor(
        public commonservice: CommonService, private route: ActivatedRoute, private router: Router, private ytbseo: YTBSEOService,
        private _fb: UntypedFormBuilder, @Inject(PLATFORM_ID) private platformId, private sharedService: SharedService, private ytbCommon: YTBCommonService) { }

    RazorpayOptions = {
        key: "",
        amount: "",
        currency: "",
        order_id: "",
        callback_url: "",
        redirect: true,
        convertionrate: "",
        paymenttatus: "",
        emailId: "",
        handler: (response) => {
            var event = new CustomEvent("payment.success",
                {
                    detail: response,
                    bubbles: true,
                    cancelable: true
                }
            );
        }
    };

    ngOnInit() {


        this.commonservice.PostBookingSuccess$.pipe(untilDestroyed(this), share()).subscribe(res => {
            console.log(res, JSON.stringify(res), "     After MakePayment ");
            if (res && res.messageInfo && res.messageInfo.successCode && res.messageInfo.successCode == "true") {
                Swal.fire({
                    title: "Payment Successfull",
                    allowOutsideClick: false,
                    confirmButtonText: "Proceed To Home Page",
                    confirmButtonColor: "green"
                }).then((ok) => {
                    this.router.navigate(['']);
                });
            } else {
                Swal.fire({
                    type: "error",
                    title: "Unable to process your Payment",
                    allowOutsideClick: false,
                    text:
                        "Unable to Process your Payment Please contact support team. Thank you"
                }).then(ok => {
                    this.router.navigate(['']);
                });

            }
        })


        this.commonservice.razorSuccess$.pipe(untilDestroyed(this), share())
            .subscribe((rzbookres) => {
                console.log(rzbookres);
                let rezorpay = this.RazorpayOptions;
                if (rzbookres && rzbookres.status == 'Success') {
                    console.log(rzbookres)
                    rezorpay.amount = rzbookres.result.pgChargedAmount;
                    rezorpay.currency = rzbookres.result.pgChargedCurrency;
                    rezorpay.convertionrate = rzbookres.result.pgConvertionRate;
                    rezorpay.redirect = rzbookres.result.redirectLink;
                    rezorpay.order_id = rzbookres.result.orderId;
                    rezorpay.paymenttatus = rzbookres.result.paymentStatus;
                    rezorpay.emailId = rzbookres.result.emailId;
                    rezorpay.key = rzbookres.result.key;
                    rezorpay.handler = (res) => {

                        Swal.fire({

                            title: "Payment Successfull",
                            allowOutsideClick: false,
                            confirmButtonText: "Proceed To Book",
                            confirmButtonColor: "green"
                        }).then((ok) => {
                            const razor_payment_info = res;
                            console.log("Razor Pay ////////" + JSON.stringify(res));
                            this.bookingdata.pgConvertionRate = rezorpay.convertionrate;
                            this.bookingdata.pgChargedCurrency = rezorpay.currency;
                            this.bookingdata.pgChargedAmount = rezorpay.amount;
                            this.bookingdata.paymentGatewayAmount = this.bookingdata.paymentGatewayDisplayAmount
                            let bookingRequest = {
                                "postBookingPaymentID": this.bookingdata.postBookingPaymentID,
                                "ytbPaymentTotalCharge": this.bookingdata.paymentGatewayAmount,
                                "paymentCurrencyCode": this.bookingdata.paymentCurrency,
                                "tempBookingNo": this.bookingdata.bookingID,
                                "pgChargedAmount": rezorpay.amount,
                                "pgChargedCurrency": rezorpay.currency,
                                "pgConvertionRate": rezorpay.convertionrate,
                                razorpay_payment_id: razor_payment_info.razorpay_payment_id,
                                orderId: razor_payment_info.razorpay_order_id,
                                paymentSignature: razor_payment_info.razorpay_signature,
                                payerID: razor_payment_info.razorpay_payment_id,
                                "bookingID": this.bookingdata.bookingID,
                                "userAddresses": {
                                    address: this.commonservice.setCarLocation(
                                        this.BillingForm.controls["address1"].value,
                                        this.BillingForm.controls["address2"].value,
                                        this.BillingForm.controls["address3"].value),
                                    city: this.BillingForm.controls["city"].value,
                                    state: this.BillingForm.controls["state"].value,
                                    zip: this.BillingForm.controls["zip"].value + this.BillingForm.controls["zip1"].value,
                                    country: this.BillingForm.controls["country"].value
                                }
                            };
                            this.commonservice.makePostBookingPaymentDetails(bookingRequest);


                        });

                    }
                    console.log(rezorpay)
                    var raz = new Razorpay(rezorpay);
                    raz.open();
                    raz.on('payment.failed', function (response) {
                        // Todo - store this information in the server
                        console.log(response.error.code);
                        console.log(response.error.description);
                        console.log(response.error.source);
                        console.log(response.error.step);
                        console.log(response.error.reason);
                        console.log(response.error.metadata.order_id);
                        console.log(response.error.metadata.payment_id);
                        this.error = response.error.reason;
                        this.spinner.hide();
                    }
                    );
                    // this.isFilter = false;
                    console.log("open")
                    console.log(raz)
                } else {
                    this.isLoading = true;
                }
            });



        this.getCountrycode();
        this.commonservice.countrySuccess$
            .pipe(untilDestroyed(this), share())
            .subscribe(countryRes => {
                if (countryRes != null && countryRes != undefined) {
                    this.allCountryList = countryRes.result;
                    this.countrylist = this.commonservice.prepareDropdownResponse(
                        countryRes.result,
                        "countryName",
                        "countryISO2"
                    );
                }
            });

        this.commonservice.countrySuccess$
            .pipe(untilDestroyed(this), share())
            .subscribe(
                concode => {
                    if (concode != null && concode != undefined) {
                        this.countrycodes = this.commonservice.preparePhoneCodesDropdownResponse(
                            concode.result,
                            "countryName",
                            "countryPhoneCode",
                            "countryImage",
                            "countryISO2",
                            "countryISO3"
                        );
                        this.countrycodes = this.countrycodes.filter(item => {
                            return item.value != "null";
                        });
                    }
                },
                err => {
                }
            );

        this.commonservice.StateList.pipe(
            untilDestroyed(this),
            share()
        ).subscribe(stateRes => {
            if (stateRes != null && stateRes != undefined) {

                
                    this.stateResponseForPersonalAddress = stateRes.result;

                    this.stateResponseForPersonalAddress.sort((a, b) => {
                    if (a['state_Name'].toUpperCase() < b['state_Name'].toUpperCase()) {
                        return -1;
                    }
                    else if (a['state_Name'].toUpperCase() > b['state_Name'].toUpperCase()) {
                        return 1;
                    } else {
                        return 0;
                    }
                    });


                this.stateList = this.commonservice.prepareDropdownResponse(
                    stateRes.result,
                    "state_Name",
                    "state_Code"
                );
                this.stateArr = this.commonservice.prepareDropdownResponse(
                    stateRes.result,
                    "state_Name",
                    "state_Code"
                );
            }
        });


        this.route.params.subscribe((params) => {
            setTimeout(() => {
                this.ytbseo.createCanonicalURL('/makeExternalPayment');
                this.ytbseo.setDynamicTitle('/makeExternalPayment');
            }, 3000);
        });


        this.route.queryParams.subscribe(res => {           
            if (res && Object.keys(res).length != 0 && res?.postBookingPaymentID) {
                this.isLoading = true;
                this.commonservice.getPostBookingPaymentDetails({
                    "postBookingPaymentID": res?.postBookingPaymentID
                })
            } else {
                  this.commonservice.logError({
                logLevel: "Error page Navigation Before",
                message:
                  "Make External Payment using query params From Make External Payment Component "
              });
                this.router.navigate(["error"]);
            }
        });




        this.commonservice.PostBookingDetailsInsertionSuccess$.pipe(untilDestroyed(this)).subscribe(res => {
            if (res.successCode && res.paymentStatus && res.paymentStatus === "5") {
                this.isLoading = false;
                this.bookingdata = res;
                this.currentCurrency = this.bookingdata?.paymentCurrency;

                this.bookingdata['paymentGatewayDisplayAmount'] = this.bookingdata.paymentGatewayAmount;
                setTimeout(() => {
                    console.log(this.viewMode);
                    if (this.currentCurrency) {
                        // let data = this.paymentCurrencyOptions.find(x => x.currency == this.currentCurrency);
                        // if (data) {
                        //     this.viewMode = data.value;
                        //     this.typeofPayment.controls['paymentCurrencyOption'].setValue(data.value);
                        //     console.log(this.typeofPayment.controls['paymentCurrencyOption'].value, "   Valiue ")
                        //     if (this.typeofPayment.controls['paymentCurrencyOption'].value == "IN") {
                        //         this.typeofPayment.controls['typeofpayment'].setValue('razor');
                        //     } else {
                        //         this.typeofPayment.controls['typeofpayment'].setValue('creditcard')
                        //     }
                        //     console.log(data.currency, this.currentCurrency);
                        //     this.modeCurrency = data.currency;
                        //     this.commonservice.paymentCurrencyConverter(this.currentCurrency, data.currency);
                        // } else {
                            this.viewMode = "US";
                            this.typeofPayment.controls['paymentCurrencyOption'].setValue('US');
                            this.typeofPayment.controls['typeofpayment'].setValue('creditcard');
                            this.modeCurrency = 'USD';
                            this.commonservice.paymentCurrencyConverter(this.currentCurrency, 'USD');
                        // }
                    }
                }, 2000);


            } else {
                Swal.fire({
                    type: "error",
                    title: "Unable to process your Payment",
                    allowOutsideClick: false,
                    text:
                        "Unable to Process your Payment Please contact support team. Thank you"
                }).then(ok => {
                    this.router.navigate(['']);
                });
            }
        });

        this.typeofPayment = new UntypedFormGroup({
            "typeofpayment": new UntypedFormControl("creditcard"),
            "billingaddress": new UntypedFormControl("sameaddress"),
            "acceptlicences": new UntypedFormControl(null, [Validators.required]),
            "flightnumber": new UntypedFormControl(null),
            paymentCurrencyOption: new UntypedFormControl('IN')
        });

        this.BillingForm = this._fb.group({
            address1: ["", [Validators.required, Validators.pattern("^[a-zA-Z0-9-@#%/&.'][a-zA-Z0-9-@#%/&.' ]+[a-zA-Z0-9-@#%/&.']*$"), this.spaceValidator.bind(this)]],
            address2: ["", [Validators.pattern("^[a-zA-Z0-9-@#%/&.'][a-zA-Z0-9-@#%/&.' ]+[a-zA-Z0-9-@#%/&.']*$"), this.spaceValidator.bind(this)]],
            address3: ["", [Validators.pattern("^[a-zA-Z0-9-@#%/&.'][a-zA-Z0-9-@#%/&.' ]+[a-zA-Z0-9-@#%/&.']*$"), this.spaceValidator.bind(this)]],
            zip1: [""],
            country: ["", Validators.required],
            zip: ["", [Validators.required, Validators.pattern("^[a-zA-Z0-9]*$")]],
            state: [""],
            city: ["", [Validators.required, Validators.pattern("^[a-zA-Z ]+[a-zA-Z]*$"), this.spaceValidator.bind(this)]]
        });

        this.PersonalForm = this._fb.group({
            zip1: [""],
            address1: ["", [Validators.required, Validators.pattern("^[a-zA-Z0-9-@#%/&.'][a-zA-Z0-9-@#%/&.' ]+[a-zA-Z0-9-@#%/&.']*$"), this.spaceValidator.bind(this)]],
            address2: ["", [Validators.pattern("^[a-zA-Z0-9-@#%/&.'][a-zA-Z0-9-@#%/&.' ]+[a-zA-Z0-9-@#%/&.']*$"), this.spaceValidator.bind(this)]],
            address3: ["", [Validators.pattern("^[a-zA-Z0-9-@#%/&.'][a-zA-Z0-9-@#%/&.' ]+[a-zA-Z0-9-@#%/&.']*$"), this.spaceValidator.bind(this)]],
            country: ["", Validators.required],
            zip: ["", [Validators.required, Validators.pattern("^[a-zA-Z0-9]*$")]],
            state: [""],
            city: ["", [Validators.required, Validators.pattern("^[a-zA-Z ]+[a-zA-Z]*$"), this.spaceValidator.bind(this)]]
        });



        this.setAddressCheckBoxDisplayValues({ value: "sameaddress" });

        this.paymentForm = this._fb.group({
            cardNumber: ["", [Validators.required, cardNumberValidator(13), Validators.pattern("^[0-9][0-9-]*$"), this.spaceValidator.bind(this)]],
            nameOnCard: ["", [Validators.required, Validators.pattern("[ a-zA-Z][a-zA-Z ]+[a-zA-Z ]$"), Validators.minLength(3), this.spaceValidator.bind(this)]],
            expiresIn: ["", [Validators.required]],
            expiryYear: ["", [Validators.required]],
            cvv: ["", [Validators.required, Validators.minLength(3), Validators.pattern("^[0-9]*$")]],
            cardType: [""]
        });



        this.commonservice.getKey();

        this.commonservice.keySuccess$.pipe(untilDestroyed(this), share()).subscribe(keyName => {
            if (keyName) {
                this.public_key = keyName.data;

            }
        });

        let currentYear = new Date().getFullYear();

        this.yearArray = Array(10).fill(currentYear).map((x, i) => x + i);
        this.monthArray = Array(12).fill(1).map((x, i) => (x + i) < 10 ? '0' + (x + i) : (x + i).toString());





        this.commonservice.PaymentCurrencyConverterValue.pipe(untilDestroyed(this), share()).subscribe((res) => {
            if (res != null && res != undefined) {
                this.bookingdata['paymentGatewayDisplayAmount'] = this.commonservice.addCurrencyValue(
                    res.result.fromamount,
                    this.bookingdata?.paymentGatewayAmount,
                    res.result.toamount
                );
            }
        });



    }
    ngAfterViewInit() {
        // this.sharedService.GeoLocationParam$.pipe(untilDestroyed(this), share()).subscribe(params => {
        //     if (params) {
        //         this.commonservice.getContactUsDetailsByISO2(params.countryCode);
        //         this.viewMode = params.countryCode
        //         console.log(this.viewMode)
        //         if (this.viewMode == 'IN') {
        //             this.typeofPayment.controls['typeofpayment'].setValue('razor');
        //         } else {
        //             this.typeofPayment.controls['typeofpayment'].setValue('creditcard');
        //             this.viewMode = "US";
        //         }
        //         this.typeofPayment.controls['paymentCurrencyOption'].setValue(this.viewMode);
        //     } else {
        //         this.typeofPayment.controls['typeofpayment'].setValue('razor');
        //         this.viewMode = 'US';
        //         this.typeofPayment.controls['paymentCurrencyOption'].setValue(this.viewMode);
        //     }
        // });
    }




    getCountryName(countryCode) {
        if (countryCode) {
            return this.countrylist.find(x => x.value === countryCode).label;

        } else {
            return "";
        }
    }

    getStateName(countryCode, stateCode) {

        if (stateCode) {
            return this.stateList.find(x => x.value === stateCode).label;

        } else {
            return "";
        }

    }



    setAddressCheckBoxDisplayValues(address) {

        address.value === "billaddress" ? this.sameaddr = true : this.sameaddr = false;
    }


    getModeOfPayment() {
        return this.typeofPayment && this.typeofPayment.controls['paymentCurrencyOption'] && this.typeofPayment.controls['paymentCurrencyOption'].value && this.typeofPayment.controls['paymentCurrencyOption'].value == 'IN'
    }


    selectViewMode(val) {
        this.viewMode = this.typeofPayment.controls['paymentCurrencyOption'].value;
        if (this.typeofPayment.controls['paymentCurrencyOption'].value == "IN") {
            this.typeofPayment.controls['typeofpayment'].setValue('razor');
        } else {
            this.typeofPayment.controls['typeofpayment'].setValue('creditcard')
        }

        let data = this.paymentCurrencyOptions.find(x => x.value == this.viewMode);
        if (data) {
            console.log(data.currency, this.currentCurrency);
            this.modeCurrency = data.currency;
            this.commonservice.paymentCurrencyConverter(this.currentCurrency, data.currency);
        }

    }


    navigateToPrivacyPolicy() {
        const url = this.router.serializeUrl(this.router.createUrlTree(["privacy-policy"]));
        if (isPlatformBrowser(this.platformId) && typeof window !== 'undefined' ) {
            window.open(url, '_blank');
        }
    }


    navigateToTermsAndConditions() {
        const url = this.router.serializeUrl(this.router.createUrlTree(["terms-and-conditions"]));
        if (isPlatformBrowser(this.platformId) && typeof window !== 'undefined' ) {
            window.open(url, '_blank');
        }
    }



    getStates(event, form: string) {
        let value =
            form == "billing"
                ? this.BillingForm.controls["country"].value
                : this.PersonalForm.controls["country"].value;
        this.commonservice.getState(value);

        if (form === 'billing') {
            let country = this.allCountryList.find(x => x.countryISO2 === value);
            console.log(country);
            if (country && country.isStateMandatory) {
              this.BillingForm.get('state')
                .setValidators([Validators.required]);
            } else {
              this.BillingForm.get('state').clearValidators();
            }
            this.BillingForm.get('state').updateValueAndValidity();
      
          }else{
            let country = this.allCountryList.find(x => x.countryISO2 === value);
            console.log(country);
            if (country && country.isStateMandatory) {
              this.PersonalForm.get('state')
                .setValidators([Validators.required]);
            } else {
              this.PersonalForm.get('state').clearValidators();
      
            }
            this.PersonalForm.get('state').updateValueAndValidity();
          }
    }

    countriesDropdown() {
        this.commonservice.getCountries();
    }

    getCountrycode() {
        this.commonservice.getCountries();
    }


    getPhoneCodeWithSymbol(countryCode) {
        if (countryCode) {
            let daat = this.allCountryList.find(x => x.countryISO2 == countryCode);
            if (daat) {
                return daat.countryPhoneCode + "-";
            }
        }
        else
            return "";
    }


    getPhoneCodeWithNumber(countryCode) {
        if (countryCode) {
            let daat = this.allCountryList.find(x => x.countryISO2 == countryCode);
            if (daat) {
                return daat.countryPhoneCode;
            }
        }
        else
            return "";
    }


    spaceValidator(dateOfBirthVal: AbstractControl) {
        let nameValue = dateOfBirthVal.value;
        if (nameValue) {
            if (nameValue) {
                let indexValue = nameValue.indexOf('  ');
                if (indexValue >= 0) {
                    return { space: true };
                } else {
                    return null;
                }
            }
        }
        return null;
    }

    validator(formType) {
        if(formType){
            
        if (formType==="personal" && this.PersonalForm && this.PersonalForm.get('state')) {
            if (this.PersonalForm.get('state').validator) {
              const validator = this.PersonalForm.get('state').validator({} as AbstractControl);
              if (validator && validator.required) {
                return true;
              }
            }
      
          }else if (formType==="billing" && this.BillingForm && this.BillingForm.get('state')) {
            if (this.BillingForm.get('state').validator) {
              const validator = this.BillingForm.get('state').validator({} as AbstractControl);
              if (validator && validator.required) {
                return true;
              }
            }
      
          }
        }
        
      }

      
    setCheckBoxDisplayValues(payment) {
        payment.value === "creditcard" ? this.creditcard = true : this.creditcard = false;
        payment.value === "paypal" ? this.paypal = true : this.paypal = false;
    }


    validateCardData(event) {
        if (event.key != "Unidentified") {
          if (!isNaN(event.key)) {
            if (
              [46, 8, 9, 27, 13].indexOf(event.keyCode) !== -1 ||
              (event.keyCode === 65 && event.ctrlKey === true) ||
              (event.keyCode === 67 && event.ctrlKey === true) ||
              (event.keyCode === 86 && event.ctrlKey === true) ||
              (event.keyCode === 88 && event.ctrlKey === true) ||
              (event.keyCode === 65 && event.metaKey === true) ||
              (event.keyCode === 67 && event.metaKey === true) ||
              (event.keyCode === 86 && event.metaKey === true) ||
              (event.keyCode === 88 && event.metaKey === true) ||
              (event.keyCode >= 35 && event.keyCode <= 39)
            ) {
              return;
            }
            if (
              (event.shiftKey || (event.keyCode < 48 || event.keyCode > 57)) &&
              (event.keyCode < 96 || event.keyCode > 105)
            ) {
              console.log("Inside of shidKE prevent Default ");
              event.preventDefault();
            } else {
              console.log("Isnide of else event . prevent Detaul ")
              let value = this.paymentForm.get('cardNumber').value;
              console.log(value)
              if (value != null && value != undefined && value != "") {
                this.checkCreditCardType(event);
              }
            }
          }
          else {
            event.preventDefault();
          }
        } else {
          let valueOfDob = this.paymentForm.get('cardNumber').value.toString();
          console.log(valueOfDob);
          if (valueOfDob) {
            let lastValue = valueOfDob.substring(valueOfDob.length - 1);
            if (!isNaN(lastValue) && event.keyCode > 105) {
              this.checkCreditCardType(event);
            } else {
              let lastValue1 = valueOfDob.substring(0, valueOfDob.length - 1);
              this.paymentForm.get('cardNumber').setValue(lastValue1);
            }
          }
        }
      }









    ngOnDestroy() {
    }


    convertToFloat(key: string) {
        if (isNaN(parseFloat(key))) {
            return 2;
        } else {
            return parseFloat(key).toFixed(2);
        }
    }






    proceedToActivityBooking() {


        console.log(this.paymentForm.value)

        let cardnumber = this.paymentForm.controls["cardNumber"].value;
        let regExp = new RegExp("-", "g");
        cardnumber = cardnumber.replace(regExp, "");
        let expiry;




        if (this.paymentForm.controls["expiryYear"].value)
            expiry = this.paymentForm.controls["expiresIn"].value + (this.paymentForm.controls["expiryYear"].value).substr(-2);


        console.log(this.commonservice.validateCurrentExpiryMonthAndYear(this.paymentForm.controls["expiryYear"].value, this.paymentForm.controls["expiresIn"].value));

        console.log(this.typeofPayment.controls['typeofpayment'].value);

        if (this.typeofPayment.controls['typeofpayment'].value == 'creditcard') {
            if (this.paymentForm.valid && this.commonservice.validateCurrentExpiryMonthAndYear(this.paymentForm.controls["expiryYear"].value, this.paymentForm.controls["expiresIn"].value)) {

                let billingInformation = this.BillingForm.value;
                if (!this.sameaddr) {
                    this.commonservice.setFormValue(billingInformation, this.PersonalForm);
                }
                if (this.BillingForm.valid && this.PersonalForm.valid) {
                    if (this.termsandcondi == "checked") {
                        this.termsandconditons = false;
                        var encrypted_data;
                        // var jsencrypt = new JSEncrypt();
                        // jsencrypt.setPublicKey(this.public_key);

                        this.isLoading = true;

                        let creditCard = {
                            cardNumber: cardnumber,
                            expirationDate: expiry,
                            cardCode: this.paymentForm.controls["cvv"].value,
                            nameOnCard: this.paymentForm.controls["nameOnCard"].value,
                            cardType: this.paymentForm.controls["cardType"].value
                        };
                        console.log(JSON.stringify(creditCard), "   Before Encryption");
                        let val = JSON.stringify(creditCard);
                        console.log(JSON.parse(val), "   Val ");
                        this.bookingdata.paymentGatewayAmount = this.bookingdata.paymentGatewayDisplayAmount;

                        encrypted_data = this.commonservice.encryptData(JSON.stringify(creditCard),this.public_key);
                        // console.log(encrypted_data, "   encryptted data ")
                        let bookingRequest =
                        {
                            "postBookingPaymentID": this.bookingdata.postBookingPaymentID,
                            "ccInfo": encrypted_data,
                            "ytbPaymentTotalCharge": this.bookingdata.paymentGatewayAmount,
                            "paymentCurrencyCode": this.bookingdata.paymentCurrency,
                            "paymentMethodType": 0,
                            "paymentSupplierType": "CC",
                            "bookingID": this.bookingdata.bookingID,
                            "tempBookingNo": this.bookingdata.tempBookingId,
                            "userAddresses": {
                                address: this.commonservice.setCarLocation(
                                    this.BillingForm.controls["address1"].value,
                                    this.BillingForm.controls["address2"].value,
                                    this.BillingForm.controls["address3"].value),
                                city: this.BillingForm.controls["city"].value,
                                state: this.BillingForm.controls["state"].value,
                                zip: this.BillingForm.controls["zip"].value + this.BillingForm.controls["zip1"].value,
                                country: this.BillingForm.controls["country"].value
                            }
                        };
                        this.commonservice.makePostBookingPaymentDetails(bookingRequest);

                    } else {
                        this.termsandconditons = true;
                    }
                } else {
                    this.commonservice.validateAllFormFields(this.BillingForm);

                    this.commonservice.validateAllFormFields(this.PersonalForm);

                    this.scrollToError();

                }
            } else {

                if (!this.commonservice.validateCurrentExpiryMonthAndYear(this.paymentForm.controls["expiryYear"].value, this.paymentForm.controls["expiresIn"].value)) {
                    this.paymentForm.controls["expiryYear"].setValue(null);
                    this.paymentForm.controls["expiresIn"].setValue(null);

                }


                this.commonservice.validateAllFormFields(this.paymentForm);

                this.scrollToError();

            }
        }
        else if (this.typeofPayment.controls['typeofpayment'].value == 'razor') {

            let billingInformation = this.BillingForm.value;
            if (!this.sameaddr) {
                this.commonservice.setFormValue(billingInformation, this.PersonalForm);
            }
            if (this.BillingForm.valid && this.PersonalForm.valid) {

                if (this.termsandcondi == "checked") {
                    this.termsandconditons = false;
                    this.razorPayBooking();
                } else {
                    this.termsandconditons = true;
                }
            } else {
                this.commonservice.validateAllFormFields(this.BillingForm);
                this.commonservice.validateAllFormFields(this.PersonalForm);
                this.scrollToError();
            }

        }
        else {

            let billingInformation = this.BillingForm.value;
            if (!this.sameaddr) {
                this.commonservice.setFormValue(billingInformation, this.PersonalForm);
            }
            if (this.BillingForm.valid && this.PersonalForm.valid) {
                if (this.termsandcondi == "checked") {
                    this.termsandconditons = false;
                    this.paypalbooking();
                } else {
                    this.termsandconditons = true;
                }
            } else {
                this.commonservice.validateAllFormFields(this.BillingForm);
                this.commonservice.validateAllFormFields(this.PersonalForm);
                this.scrollToError();
            }
        }
    }

    razorPayBooking() {

        if (this.termsandcondi == "checked") {
            this.isLoading = true;
            this.termsandconditons = false;
            let paypalRequest = {
                creditCard: {
                    cardNumber: "",
                    expirationDate: "",
                    cardCode: ""
                },
                "tempBookingId": this.bookingdata.postBookingPaymentID,
                currency: this.bookingdata.paymentCurrency,
                amount: this.bookingdata?.paymentGatewayAmount?.toString(),
                customerAddress: {
                    address: this.commonservice.setCarLocation(
                        this.BillingForm.controls["address1"].value,
                        this.BillingForm.controls["address2"].value,
                        this.BillingForm.controls["address3"].value),
                    city: this.BillingForm.controls["city"].value,
                    state: this.BillingForm.controls["state"].value,
                    zip: this.BillingForm.controls["zip"].value + this.BillingForm.controls["zip1"].value,
                    country: this.BillingForm.controls["country"].value,
                },
                paymentType: "PP"
            };
            this.commonservice.makeRazorPayment(paypalRequest);
        } else {
            this.termsandconditons = true;
            this.paymentForm.markAllAsTouched();
            this.BillingForm.markAllAsTouched();
            this.scrollToError();
        }

    }

    paypalbooking() {
        this.bookingdata.paymentGatewayAmount = this.bookingdata.paymentGatewayDisplayAmount
        this.isLoading = true;
        let paypalRequest = {
            creditCard: {
                cardNumber: "",
                expirationDate: "",
                cardCode: ""
            },
            currency: this.bookingdata.paymentCurrency,
            "tempBookingId": this.bookingdata.postBookingPaymentID,
            amount: this.bookingdata?.paymentGatewayAmount?.toString(),
            customerAddress: {
                address: this.commonservice.setCarLocation(
                    this.BillingForm.controls["address1"].value,
                    this.BillingForm.controls["address2"].value,
                    this.BillingForm.controls["address3"].value),
                city: this.BillingForm.controls["city"].value,
                state: this.BillingForm.controls["state"].value,
                zip: this.BillingForm.controls["zip"].value + this.BillingForm.controls["zip1"].value,
                country: this.BillingForm.controls["country"].value,
            },
            paymentType: "PP",
            successUrl: environment.angularUrl + "payments?type=success&module=PB&postBookingPaymentID=" + this.bookingdata.postBookingPaymentID,
            failureUrl: environment.angularUrl + "payments?type=failure&module=PB&postBookingPaymentID=" + this.bookingdata.postBookingPaymentID
        };



        this.commonservice.makePaypalPayment(paypalRequest);


        this.commonservice.PaypalDetails.pipe(
            untilDestroyed(this),
            share()
        ).subscribe(bookres => {
            if (bookres && bookres.statusCode === 1) {
                this.isLoading = false;
                this.bookingdata.pgConvertionRate = bookres.result.pgConvertionRate;
                this.bookingdata.pgChargedCurrency = bookres.result.pgChargedCurrency;
                this.bookingdata.pgChargedAmount = bookres.result.pgChargedAmount;
                this.bookingdata.userAddresses = {
                    address: this.commonservice.setCarLocation(
                        this.BillingForm.controls["address1"].value,
                        this.BillingForm.controls["address2"].value,
                        this.BillingForm.controls["address3"].value),
                    city: this.BillingForm.controls["city"].value,
                    state: this.BillingForm.controls["state"].value,
                    zip: this.BillingForm.controls["zip"].value + this.BillingForm.controls["zip1"].value,
                    country: this.BillingForm.controls["country"].value,
                };
                this.sharedService.setPaypalBookingDetails(this.bookingdata);
                if (isPlatformBrowser(this.platformId) && typeof window !== 'undefined' ) {

                    window.open(
                        bookres.result.redirectLink,
                        "_self",
                        "width=500,height=500"
                    );
                }
            } else {

                Swal.fire({
                    type: "error",
                    title: "Paypal Not working",
                    allowOutsideClick: false,
                    text:
                        "Unable to Process your Payment through Paypal. Please try with another payment type. Thank you"
                }).then(ok => { });
            }
        });








    }


    scrollTo(el: Element): void {
        if (el) {
            el.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
    }

    scrollToError(): void {
        const firstElementWithError = document.querySelector('.ng-invalid[formControlName]');
        this.scrollTo(firstElementWithError);
    }





  checkCreditCardType(event) {
    // alert(event);

    let cardType;
    var creditCardNo = this.paymentForm.get('cardNumber').value;
    creditCardNo = creditCardNo != null ? creditCardNo.split('-').join("") : '';


    // alert(creditCardNo);
    if (creditCardNo != '') {
      cardType = creditCardType(creditCardNo);

      console.log(cardType);

      // alert(JSON.stringify(cardType));

      if (cardType && cardType[0] && cardType[0].code) {
        if (cardType[0].code.size)
          this.cvvLength = cardType[0].code.size;
      } else {
        this.cvvLength = 4;
      }
    }

    if (creditCardNo == '') {
      this.cardImage = '';
    }

    if (creditCardNo != null && creditCardNo != undefined && creditCardNo != '') {
      if (creditCardNo.length >= 19) {
        event.preventDefault();
      } else {
        if (cardType && cardType.length > 0) {
          let formattedCardObj = this.ytbCommon.formatPaymentCards(cardType, B2C_LOOKUP.PaymentCards, creditCardNo);
          this.paymentForm.get('cardNumber').setValue(formattedCardObj.cardNo);
          this.paymentForm.get('cardType').setValue(formattedCardObj.cardCompany);

          this.cardImage = formattedCardObj.cardLogo;
        } else {
          this.cvvLength = 4;
          this.cardImage = '';
        }
      }
    }





  }


















}



function cardNumberValidator(minLength) {
    return (control: AbstractControl): { [key: string]: boolean } | null => {
        if (control.value != '' && control.value != null) {
            let cardnumber = control.value.split('-').join("");
            let cardnumberLength = cardnumber.length;
            if (cardnumberLength < minLength) {
                return { 'cardNumber': true };
            }
        }
    }
}

